<ion-app>
  <ion-menu contentId="mainMenu" type="push" swipeGesture="false">
    <ion-content>
      <ion-list id="inbox-list">
        <ion-list-header>Menu</ion-list-header>
        <ion-menu-toggle [hidden]="!dashboardOnConfig">
          <ion-item (click)="changePage('/dashboard')">
            <ion-icon slot="start" name="bar-chart-outline"></ion-icon>
            <ion-label> {{'DASHBOARD.DASHBOARD' | translate}} </ion-label>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle [hidden]="!hasCatalogAccess">
          <ion-item (click)="changePage('/catalog')">
            <ion-icon slot="start" name="list-outline"></ion-icon>
            <ion-label> {{'MENU.PROP_CATALOG_TITLE' | translate}} </ion-label>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle [hidden]="!hasParcelAccess">
          <ion-item (click)="changePage('/parcels')">
            <ion-icon slot="start" name="layers-outline"></ion-icon>
            <ion-label> {{'MENU.CREATE_PARCEL' | translate}} </ion-label>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle [hidden]="!hasBuildingAccess">
          <ion-item (click)="changePage('/buildings')">
            <ion-icon slot="start" name="business-outline"></ion-icon>
            <ion-label> {{'MENU.CREATE_BUILDING' | translate}} </ion-label>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle [hidden]="!hasMapAccess">
          <ion-item (click)="changePage('/map')">
            <ion-icon slot="start" name="map-outline"></ion-icon>
            <ion-label> {{'MENU.MAP' | translate}} </ion-label>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle [hidden]="!hasAdvancedSearchAccess">
          <ion-item (click)="changePage('/advanced-search')">
            <ion-icon slot="start" name="search-outline"></ion-icon>
            <ion-label> {{'MENU.PROP_SEARCH' | translate}} </ion-label>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle [hidden]="!hasReportAccess">
          <ion-item (click)="changePage('/reports')">
            <ion-icon name="print-outline" slot="start"></ion-icon>
            <ion-label>{{ "MENU.REPORTS" | translate }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle [hidden]="!hasSecurityAccess">
          <ion-item (click)="changePage('/security')">
            <ion-icon slot="start" name="shield-checkmark-outline"></ion-icon>
            <ion-label> {{'MENU.SECURITY' | translate}} </ion-label>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle [hidden]="!hasOtherCataloguesAccess">
          <ion-item (click)="changePage('/other-catalogues')">
            <ion-icon slot="start" name="list-outline"></ion-icon>
            <ion-label> {{'HOME.OTHER_CATALOGUES' | translate}} </ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>
    </ion-content>

    <ion-item lines="none" *ngIf="versionUi">
      <ion-label class="version-label">U: {{versionUi}} / A: {{versionApi}} / D: {{versionDb}}</ion-label>
    </ion-item>

    <ion-footer>
      <ion-item *ngIf="helpUrl">
        <a [href]="helpUrl" target="_blank">{{'APP_COMPONENT.USER_MANUAL' | translate}}</a>
      </ion-item>
      <ion-item>
        <ion-label> {{'APP_COMPONENT.BLACK_THEME' | translate}} </ion-label>
        <ion-toggle [(ngModel)]="toggle" (ionChange)="toggleTheme($event)" slot="end"></ion-toggle>
      </ion-item>

      <ion-item>
        <ion-label title="{{ 'APP_COMPONENT.RECIEVE_EMAIL_TOOLTIP' | translate }}">
          {{ 'APP_COMPONENT.RECIEVE_EMAIL' | translate }}
        </ion-label>
        <ion-toggle [(ngModel)]="recieveEmail" (ionChange)="toggleRecieveEmail($event)" slot="end">
        </ion-toggle>
      </ion-item>


      <ion-item lines="none">
        <ion-label>{{'APP_COMPONENT.FIRST_PAGE_SELECTION' | translate}}</ion-label>
        <ion-select placeholder="{{'PROP.SELECT' | translate}}" interface="popover"
          [interfaceOptions]="{ cssClass: 'wide-popover' }" [(ngModel)]="selectedValue"
          (ionChange)="onSelectChange($event)" slot="end">
          <ion-select-option value="1">{{'APP_COMPONENT.FIRST_PAGE_SELECTION' | translate}}</ion-select-option>
          <ion-select-option *ngIf="hasE9Access" value="2">{{'HOME.E9' | translate}}</ion-select-option>
          <ion-select-option value="3">{{'DASHBOARD.DASHBOARD' | translate}}</ion-select-option>
          <ion-select-option *ngIf="hasCatalogAccess" value="4">{{'HOME.PROP_CATALOG_TITLE' |
            translate}}</ion-select-option>
          <ion-select-option *ngIf="hasParcelAccess" value="5">{{'MENU.CREATE_PARCEL' | translate}}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item lines="none" class="footer-row no-frame">
        <ion-label>{{ 'APP_COMPONENT.LANGUAGE' | translate }}</ion-label>
        <ion-segment [formControl]="language" slot="end" class="lang-segment" mode="ios">
          <ion-segment-button value="en"><ion-label>English</ion-label></ion-segment-button>
          <ion-segment-button value="el"><ion-label>Ελληνικά</ion-label></ion-segment-button>
        </ion-segment>
      </ion-item>


    </ion-footer>
  </ion-menu>
  <ion-router-outlet id="mainMenu"></ion-router-outlet>
</ion-app>